import { useCallback, useEffect, useState } from "react";
import { MessagesService } from "../../../../../services/messages";
import { useAppDispatch } from "../../../../../store";
import { setUnreadMessages } from "../../../../../acions/actionsCreators/unreadMessages";

export const usePollConversations = (setData: React.Dispatch<React.SetStateAction<any[]>>) => {
  const dispatch = useAppDispatch();

  const [isPolling, setIsPolling] = useState<boolean>(false);

  const getHasUnreads = useCallback((data: any): boolean => {
    let hasUnreads: boolean = false;

    data.forEach((group: any) => {
      group.conversations.forEach((conv: any) => {
        if (conv.hasUnreadMessages) {
          hasUnreads = true;
        }
      });
    });

    return hasUnreads;
  }, []);

  const pull = useCallback(async () => {
    try {
      if (!isPolling) {
        setIsPolling(true);

        const res: any = await MessagesService.fetchConversations();

        setData(res);

        dispatch(setUnreadMessages(getHasUnreads(res)));

        setIsPolling(false);
      }
    } catch {}
  }, [setData, dispatch, isPolling, getHasUnreads]);

  useEffect(() => {
    const i = setInterval(async () => {
      await pull();
    }, 2000);

    return () => clearInterval(i);
  }, [pull]);
};
